import { ArrowUpRight } from "lucide-react";

const SourcingPartners = () => {
    const partners = [
        {
            name: "SAIL",
            logo: "/images/sail.jpg",
            domain: "sail.co.in"
        },
        {
            name: "Jindal Steel & Power",
            logo: "/images/jindal-steel-and-power.png",
            domain: "jindalsteelpower.com"
        },
        {
            name: "JSW Steel",
            logo: "/images/jsw-steel.jpg",
            domain: "jsw.in"
        },
    ];

    return (
        <section className="py-20 bg-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">

                    {/* Logos Grid */}
                    <div className="w-full lg:w-1/2">
                        <div className="flex flex-wrap justify-center gap-4 sm:gap-6">
                            {partners.map((partner) => (
                                <div
                                    key={partner.name}
                                    className="group flex items-center justify-center p-4 sm:p-6 bg-white border border-slate-100 rounded-3xl hover:shadow-2xl transition-all duration-500 hover:border-accent/20 w-[calc(50%-8px)] sm:w-[calc(33.33%-16px)] aspect-square sm:aspect-[4/5] overflow-hidden"
                                >
                                    <div className="w-full h-20 sm:h-64 relative">
                                        <img
                                            src={partner.logo}
                                            alt={`${partner.name} Logo`}
                                            className="absolute inset-0 w-full h-full object-contain transition-all duration-500 transform group-hover:scale-105"
                                            onError={(e) => {
                                                e.target.onerror = null;
                                                e.target.parentNode.innerHTML = `<div class="flex items-center justify-center h-full"><span class="text-[10px] sm:text-xs font-bold text-slate-400 capitalize">${partner.name}</span></div>`;
                                            }}
                                        />
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Content */}
                    <div className="w-full lg:w-1/2 text-center lg:text-left">
                        <h2 className="text-accent font-bold tracking-wide uppercase text-sm mb-3">Our Partners</h2>
                        <h3 className="text-3xl md:text-4xl font-bold font-heading text-primary mb-6">
                            Sourcing high-grade steel from the most trusted mills in India.
                        </h3>
                        <p className="text-slate-600 text-lg leading-relaxed mb-8">
                            We specialize in tailor-made offerings based on your specifications, ensuring that you receive only the best materials for your projects.
                            Our strong partnerships with industry leaders allow us to guarantee quality, consistency, and timely delivery.
                        </p>
                        <div className="flex flex-wrap gap-4 justify-center lg:justify-start">
                            <div className="flex items-center gap-2 text-primary font-medium">
                                <span className="w-2 h-2 bg-accent rounded-full"></span>
                                Official Sourcing Partners
                            </div>
                            <div className="flex items-center gap-2 text-primary font-medium">
                                <span className="w-2 h-2 bg-accent rounded-full"></span>
                                Certified Quality
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default SourcingPartners;
